'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _CellPhotoBlock = require('../OMComponents/OMPropertyCells/components/CellPhotoBlock/CellPhotoBlock');var _CellPhotoBlock2 = _interopRequireDefault(_CellPhotoBlock);
var _buildVideoLinks = require('../../utils/buildVideoLinks');var _buildVideoLinks2 = _interopRequireDefault(_buildVideoLinks);
var _formatPropertyPrice = require('../../helpers/formatPropertyPrice');var _formatPropertyPrice2 = _interopRequireDefault(_formatPropertyPrice);
var _DetailsLink = require('./DetailsLink');var _DetailsLink2 = _interopRequireDefault(_DetailsLink);
var _PropertyNearbyCell = require('./PropertyNearbyCell.scss');var styles = _interopRequireWildcard(_PropertyNearbyCell);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}var

PropertyNearbyCell = function (_React$Component) {_inherits(PropertyNearbyCell, _React$Component);function PropertyNearbyCell() {var _temp, _this, _ret;_classCallCheck(this, PropertyNearbyCell);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.
    handleToggleFavorite = function () {var _this$props =
      _this.props,property = _this$props.property,toggleFavorite = _this$props.toggleFavorite;
      toggleFavorite(property.id, '', true);
    }, _temp), _possibleConstructorReturn(_this, _ret);}PropertyNearbyCell.prototype.
  render = function render() {var _props =
    this.props,property = _props.property,translate = _props.translate,isMobile = _props.isMobile,className = _props.className,locale = _props.locale,isFavorite = _props.isFavorite;
    var propertyPhoto = property.images.at(0) || null;
    var videos = property.videos;
    var propertyVideoPoster = videos && videos[0] && videos[0].id && (0, _buildVideoLinks2.default)(videos[0]).thumbnail;
    var propertyImages = property.images.map(function (image) {return { thumbnail: image.thumbnail || image };});var
    banners = property.banners;

    var formattedPrice = (0, _formatPropertyPrice2.default)({
      locale: locale,
      isMobile: isMobile,
      translate: translate,
      minPrice: banners.starting_price });


    return (
      _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.wrapper, className) },
        _react2.default.createElement('div', { className: styles.content },
          _react2.default.createElement('div', { className: styles.details },
            _react2.default.createElement('div', { className: styles.info },
              _react2.default.createElement('h3', {
                  style: {
                    WebkitBoxOrient: 'vertical' },

                  className: styles.title },

                banners.title[locale] || banners.title.he),

              _react2.default.createElement('p', {
                  style: {
                    WebkitBoxOrient: 'vertical' },

                  className: styles.description },

                banners.description[locale] || banners.description.he)),


            _react2.default.createElement(_DetailsLink2.default, {
              translate: translate,
              locale: locale,
              propertyId: property.id })),


          _react2.default.createElement('div', { className: styles.images },
            _react2.default.createElement(_CellPhotoBlock2.default, {
              className: 'largePhoto',
              price: formattedPrice,
              photo: propertyPhoto,
              images: propertyImages,
              isRtl: this.props.isRtl,
              isFavorite: isFavorite,
              toggleFavorite: this.handleToggleFavorite,
              withoutCurrency: true,
              withDotsPagination: true,
              classNameProperty:
              property.images.length > 1 ? styles.slider : '',

              videoPoster: propertyVideoPoster,
              id: property.id,
              priceClassName: styles.price })),


          isMobile &&
          _react2.default.createElement(_DetailsLink2.default, {
            translate: translate,
            locale: locale,
            propertyId: property.id }))));





  };return PropertyNearbyCell;}(_react2.default.Component);


PropertyNearbyCell.propTypes = {
  property: _propTypes2.default.object,
  translate: _propTypes2.default.func,
  locale: _propTypes2.default.string,
  isRtl: _propTypes2.default.bool,
  isMobile: _propTypes2.default.bool,
  className: _propTypes2.default.string,
  isFavorite: _propTypes2.default.bool,
  toggleFavorite: _propTypes2.default.func };exports.default =


PropertyNearbyCell;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PropertyNearbyCell/PropertyNearbyCell.js
// module id = 2856
// module chunks = 0